import { createClient, } from 'contentful';
export class ContentfulApi {
    constructor(config) {
        var _a, _b, _c;
        this.fetchData = async ({ contentType, entryId, locale = 'en', query = {}, }) => {
            try {
                const response = entryId
                    ? (await this.client.getEntry(entryId, { locale }))
                    : (await this.client.getEntries(Object.assign({ content_type: contentType, locale }, query))).items;
                return response;
            }
            catch (error) {
                return error instanceof Error
                    ? { error: error.message }
                    : { error: 'Unknown error occurred' };
            }
        };
        this.client = createClient({
            space: (_a = config === null || config === void 0 ? void 0 : config.spaceId) !== null && _a !== void 0 ? _a : process.env.REACT_APP_CONTENTFUL_SPACE_ID,
            accessToken: (_b = config === null || config === void 0 ? void 0 : config.accessToken) !== null && _b !== void 0 ? _b : process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
            environment: (_c = config === null || config === void 0 ? void 0 : config.environment) !== null && _c !== void 0 ? _c : process.env.REACT_APP_CONTENTFUL_ENVIRONMENT,
        });
    }
}
const contentfulApi = new ContentfulApi({
    spaceId: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
    environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT,
});
const contentfulApi2 = new ContentfulApi({
    spaceId: process.env.REACT_APP_CONTENTFUL_SPACE_ID2,
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN2,
    environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT2,
});
const useContentfulApi = (props) => {
    const space = (props === null || props === void 0 ? void 0 : props.space) || 'main';
    if (space === 'main') {
        return contentfulApi;
    }
    return contentfulApi2;
};
export default useContentfulApi;
